export const DELETE_OR_CANCEL_EVENT_CLICKED = 'DeleteOrCancelEventClicked';
export const DELETE_OR_CANCEL_EVENT_CLICKED_FROM_MAIL = 'DeleteOrCancelEventClickedFromMail';
export const DELETE_OR_CANCEL_EVENT_ABORT = 'DeleteOrCancelEventAbort';
export const DELETE_OR_CANCEL_EVENT_CONFIRM_CLICKED = 'DeleteEvent';
export const DELETE_OR_CANCEL_EVENT_COMPLETE = 'DeleteOrCancelEventComplete';
export const DELETE_OR_CANCEL_EVENT_RETRY_CLICKED = 'DeleteOrCancelEventRetryClicked';
export const EVENT_CLICKED = 'EventClicked';
export const SERIES_DETAILS_CLICKED = 'SeriesDetailsClicked';
export const ALL_INSTANCES_CLICKED = 'AllInstancesDetailsClicked';
export const ALL_INSTANCES_SPOKE_LOADED = 'AllInstancesSpokeLoaded';
export const RSVP_EVENT_CLICKED = 'RSVPEventClicked';
export const RSVP_EVENT_CLICKED_FROM_MAIL = 'RSVPEventClickedFromMail';
export const RSVP_EVENT_SEND = 'meetingMessageAction';
export const RSVP_EVENT_COMPLETE = 'RSVPEventComplete';
export const RSVP_OVERLAY_CLICKED = 'RSVPOverlayClicked';
export const VIEW_BUTTON_CLICKED = 'ViewButtonClicked';
export const EVENT_READING_PANE_LOADED = 'EventReadingPaneLoaded';
export const RSVP_RENDERED = 'RsvpRendered';
export const EVENT_CAPTURE_DISCARDED = 'EventDiscarded';
export const EVENT_EDIT_CLICKED = 'EventEditClicked';
export const EVENT_EDIT_CLICKED_FROM_MAIL = 'EventEditClickedFromMail';
export const SAVE_CAL_EVENT = 'SaveCalendarEvent';
export const EVENT_ACTION_SELECT_SINGLE_OR_SERIES_ABORT = 'EventActionSelectSingleOrSeriesAbort';

// LCR tracking constants
export const MAIL_LIST_RENDERED = 'MailListRendered';
export const AV_MOUNT_UPDATE_COMPLETE = 'AV_MountUpdate_Complete';
export const DV_RENDER_COMPLETE = 'DV_Render_Complete';
// Triggered when PeopleListHubWrapper is rendered with contact items.
export const PEOPLE_LIST_RENDERED = 'PeopleListRendered';

// Triggered for MeControl
export const ME_CONTROL_EXPANDED = 'MeControlExpanded';
